export const LOAD_SETTINGS = 'APP/LOAD_SETTINGS';
export const LOAD_SIGNALR = 'APP/LOAD_SIGNALR';
export interface AppDispatchTypes {
  type: string;
  payload?: any;
}